import { useTranslation } from 'next-i18next'

export default function IntroMessage(): React.ReactElement {
  const { t } = useTranslation('encyclopedia')

  return <div className="p-6 rounded bg-white shadow-experimental">{t('introMessage')}</div>
}
